import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _changePasswordRequest = {};
var _changePasswordResponse = {};
var _commonCustomValue = {
    numValue: 'DOUBLE',
    dateValue: 'google.protobuf.Timestamp',
    listValue: '_commonListValue',
    mapValue: '_commonMapValue',
};
var _commonListValue = { value: '_commonCustomValue' };
var _commonMapValue = { value: 'Map#_commonCustomValue' };
var _customField = { value: '_customValue' };
var _customValue = {
    numValue: 'DOUBLE',
    dateValue: 'google.protobuf.Timestamp',
    listValue: '_listValue',
    mapValue: '_mapValue',
};
var _getWebauthnChallengeRequest = {};
var _getWebauthnChallengeResponse = {};
var _identity = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    identityProfile: '_identityProfile',
};
var _identityProfile = { customFields: '_customField' };
var _listValue = { value: '_customValue' };
var _loginCallbackRequest = {};
var _loginV2Request = {};
var _loginWithIdpConnectionRequest = {};
var _loginWithIdpConnectionTokenParamsRequest = {};
var _logoutRequest = {};
var _mapValue = { value: 'Map#_customValue' };
var _rawHttpRequest = { body: 'BYTES' };
var _rawHttpResponse = { body: 'BYTES' };
var _registerV2Request = { profile: '_identityProfile' };
var _signOnRequest = { profile: '_identityProfile' };
var _signOnResponse = { identity: '_identity' };
var _stateMachineResponse = {
    identity: '_identity',
    additionalData: 'Map#_commonCustomValue',
};
var _verifyRequest = {};
function resolveWixIamAuthenticationV1AuthenticationServiceUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/iam/authentication',
                destPath: '',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/iam/wix/google',
                destPath: '/v1/sso/callback/root/0e6a50f5-b523-4e29-990d-f37fa2ffdd69',
            },
            {
                srcPath: '/authentication',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/iam/authentication',
                destPath: '',
            },
            {
                srcPath: '/iam/authentication',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/iam/authentication',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/iam/authentication',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/iam/authentication',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/iam/authentication',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/authentication',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/iam/authentication',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/iam/authentication/v2/sign-on',
                destPath: '/v2/sign-on',
            },
            {
                srcPath: '/iam/authentication/v1/logout',
                destPath: '/v1/logout',
            },
            {
                srcPath: '/iam/authentication/v2/change-password',
                destPath: '/v2/change-password',
            },
            {
                srcPath: '/iam/authentication/v2/verify',
                destPath: '/v2/verify',
            },
            {
                srcPath: '/iam/authentication/v2/login',
                destPath: '/v2/login',
            },
            {
                srcPath: '/iam/authentication/v2/register',
                destPath: '/v2/register',
            },
            {
                srcPath: '/iam/authentication/v2',
                destPath: '/v2',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Registers a new member.
 *
 * Typically, after a successful registration, you generate and use member tokens for the
 * registered member so that subsequent API calls are called as part of a member session.
 * Use the `sessionToken` in the response to [get the site member's access and refresh tokens](https://dev.wix.com/docs/go-headless/coding/rest-api/visitors-and-members/handle-members-with-custom-login#get-the-site-members-access-and-refresh-tokens).
 *
 * If the email used to register the member already exists as a contact email, the registering
 * member need to verify the email address using a code that is sent to the address.
 */
export function registerV2(payload) {
    var _a = serializer(_registerV2Request, {
        _customField: _customField,
        _customValue: _customValue,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_stateMachineResponse, {
        _commonCustomValue: _commonCustomValue,
        _commonListValue: _commonListValue,
        _commonMapValue: _commonMapValue,
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __registerV2(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'POST',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.RegisterV2',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v2/register',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __registerV2.fromReq = fromReq;
    __registerV2.__isAmbassador = true;
    return __registerV2;
}
/**
 * Logs in an existing member.
 *
 * Typically, after a successful login, you generate and use member tokens for the
 * logged-in member so that subsequent API calls are called as part of a member session.
 * Use the `sessionToken` in the response to [get the site member's access and refresh tokens](https://dev.wix.com/docs/go-headless/coding/rest-api/visitors-and-members/handle-members-with-custom-login#get-the-site-members-access-and-refresh-tokens).
 */
export function loginV2(payload) {
    var _a = serializer(_loginV2Request, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_stateMachineResponse, {
        _commonCustomValue: _commonCustomValue,
        _commonListValue: _commonListValue,
        _commonMapValue: _commonMapValue,
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __loginV2(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'POST',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.LoginV2',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v2/login',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __loginV2.fromReq = fromReq;
    __loginV2.__isAmbassador = true;
    return __loginV2;
}
/**
 * Changes the password of a logged-in member. The member must have a valid session to use this method.
 *
 * The member's session remains valid after password change.
 *
 * The new password must meet the site's configured password requirements for length
 * and complexity. These requirements are enforced automatically when processing the request.
 */
export function changePassword(payload) {
    var _a = serializer(_changePasswordRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_changePasswordResponse, {}).fromJSON;
    function __changePassword(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'POST',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.ChangePassword',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v2/change-password',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __changePassword.fromReq = fromReq;
    __changePassword.__isAmbassador = true;
    return __changePassword;
}
export function loginWithIdpConnection(payload) {
    var _a = serializer(_loginWithIdpConnectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __loginWithIdpConnection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'GET',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.LoginWithIdpConnection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v1/sso/login/{tenantId}/{idpConnectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                        protoPath: '/v1/sso/login/{tenantId}/{idpConnectionId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData, true),
                },
            ],
        };
        return metadata;
    }
    __loginWithIdpConnection.fromReq = fromReq;
    __loginWithIdpConnection.__isAmbassador = true;
    return __loginWithIdpConnection;
}
/** REQUIRES path params `tenant_type`, `tenant_id` and `idp_connection_id` */
export function loginWithIdpConnectionCallback(payload) {
    var _a = serializer(_rawHttpRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __loginWithIdpConnectionCallback(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'GET',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.LoginWithIdpConnectionCallback',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v1/sso/callback/{tenantType}/{tenantId}/{idpConnectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                        protoPath: '/v1/sso/callback/{tenantType}/{tenantId}/{idpConnectionId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __loginWithIdpConnectionCallback.fromReq = fromReq;
    __loginWithIdpConnectionCallback.__isAmbassador = true;
    return __loginWithIdpConnectionCallback;
}
export function loginCallback(payload) {
    var _a = serializer(_loginCallbackRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __loginCallback(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'GET',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.LoginCallback',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v1/callback',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __loginCallback.fromReq = fromReq;
    __loginCallback.__isAmbassador = true;
    return __loginCallback;
}
/**
 * Log in with an IDP connection using a set of tokens that will be passed to the IDP for validation.
 * This can be used when the IDP can perform authentication directly with the client and then provide a token that
 * proves that authentication succeeded, eg. OIDC on a native app or sign in with Google when using their SDK.
 */
export function loginWithIdpConnectionTokenParams(payload) {
    var _a = serializer(_loginWithIdpConnectionTokenParamsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_stateMachineResponse, {
        _commonCustomValue: _commonCustomValue,
        _commonListValue: _commonListValue,
        _commonMapValue: _commonMapValue,
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __loginWithIdpConnectionTokenParams(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'POST',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.LoginWithIdpConnectionTokenParams',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v1/sso/login-with-token-params',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __loginWithIdpConnectionTokenParams.fromReq = fromReq;
    __loginWithIdpConnectionTokenParams.__isAmbassador = true;
    return __loginWithIdpConnectionTokenParams;
}
/**
 * Authenticates a member without credentials and returns a session token.
 *
 * This method provides authentication that automatically creates or updates
 * member accounts as needed during the authentication process.
 * Use this only for trusted integrations and scenarios where you already have verified user information.
 */
export function signOn(payload) {
    var _a = serializer(_signOnRequest, {
        _customField: _customField,
        _customValue: _customValue,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_signOnResponse, {
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __signOn(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'POST',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.SignOn',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v2/sign-on',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __signOn.fromReq = fromReq;
    __signOn.__isAmbassador = true;
    return __signOn;
}
/**
 * Terminates the member's session and clears authentication cookies.
 *
 * Returns the following:
 * - `body`: HTML content for the logout response
 * - `statusCode`: HTTP status code (200 for success, 302 for redirect)
 * - `headers`: Array of key-value pairs including:
 * - `Set-Cookie` headers to remove all session cookies
 * - `Location` header (when `postLogoutRedirectUri` is provided, with 302 status)
 */
export function logout(payload) {
    var _a = serializer(_logoutRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __logout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'GET',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.Logout',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v1/logout',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __logout.fromReq = fromReq;
    __logout.__isAmbassador = true;
    return __logout;
}
/**
 * Verifies a multi-factor authentication challenge and progresses through the authentication process.
 *
 * Use this endpoint to submit verification for authentication flows that require additional steps
 * such as SMS codes, email verification, TOTP, push notifications, or WebAuthn. The `stateToken`
 * from the initial authentication response is required.
 */
export function verify(payload) {
    var _a = serializer(_verifyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_stateMachineResponse, {
        _commonCustomValue: _commonCustomValue,
        _commonListValue: _commonListValue,
        _commonMapValue: _commonMapValue,
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __verify(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'POST',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.Verify',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v2/{factorType}/verify',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __verify.fromReq = fromReq;
    __verify.__isAmbassador = true;
    return __verify;
}
/**
 * Retrieves a WebAuthn challenge for authentication.
 *
 * Returns the challenge data needed to perform WebAuthn authentication. If no `loginId` is
 * provided, returns an anonymous challenge for usernameless authentication flows.
 */
export function getWebauthnChallenge(payload) {
    var _a = serializer(_getWebauthnChallengeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getWebauthnChallengeResponse, {}).fromJSON;
    function __getWebauthnChallenge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'GET',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.GetWebauthnChallenge',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v2/login/webauthn-challenge',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getWebauthnChallenge.fromReq = fromReq;
    __getWebauthnChallenge.__isAmbassador = true;
    return __getWebauthnChallenge;
}
//# sourceMappingURL=http.impl.js.map